import React from 'react'
import SideBar from '../../Components/SideBar'
import '../../accests/Css/Login.css'
import UserTable from '../../Components/Usertable'

export default function DataUser() {
  return (
    <div style={{ overflowX: "hidden", height: "100vh" }} className='bg-gray-300 '>
      <SideBar />
      <div className='lg:ml-44'>
        <UserTable />
      </div>
    </div>
  )
}
